<section>
  <ng-container *ngIf="isLoading; else loadedTemplate">
    <app-loading [onlyIcon]="true"></app-loading>
  </ng-container>
  <ng-template #loadedTemplate>
    <div class="annual-sales-chart">
      <div>
        <div>
          <h2>{{ 'HOME.ANNUAL_SALES' | i18nextEager }}</h2>
          <div
            *ngIf="data.years.length > 0 && objectivesData?.consumption && objectivesData?.margin"
            class="year-selector"
          >
            <mat-icon
              class="selector selector--left"
              [ngClass]="{ disabled: yearIndexMin }"
              (click)="changeYear('prev')"
              >chevron_left</mat-icon
            >
            <span>{{ year }}</span>
            <mat-icon
              class="selector selector--right"
              [ngClass]="{ disabled: yearIndexMax }"
              (click)="changeYear('next')"
              >chevron_right</mat-icon
            >
          </div>
        </div>
        <button
          *ngIf="data.years.length > 0 && objectivesData?.consumption && objectivesData?.margin"
          class="secondary"
          (click)="openObjectivesDialog()"
        >
          {{ 'ANNUAL_SALES_CHART.OBJECTIVES' | i18nextEager }}
        </button>
      </div>
      <p
        *ngIf="data.years.length === 0 && !objectivesData?.consumption && !objectivesData?.margin"
        class="annual-sales-chart__error"
      >
        {{ 'COMMONS.WITHOUT_DATA' | i18nextEager }}
      </p>
      <div
        echarts
        [options]="annualSalesChartOptions"
        class="annual-sales-chart"
        (chartInit)="onChartInit($event)"
      ></div>
    </div>
  </ng-template>
</section>
